import BranchFilterImage from '../assets/images/features/branches/filter_branch.png'
import BranchList from '../assets/images/features/branches/branch_list.png'
import InviteBranch from '../assets/images/features/branches/invite_teammate.png'
import ExportBranch from '../assets/images/features/branches/export_branch.png'
import BranchCta from '../assets/images/features/branches/branch_cta.png'
import branchusecase01 from '../assets/images/features/branches/branch_usecase01.png'
import branchusecase02 from '../assets/images/features/branches/branch_usecase02.png'
import branchusecase03 from '../assets/images/features/branches/branch_usecase03.png'
import branchusecase04 from '../assets/images/features/branches/branch_usecase04.png'
import emailusecase01 from '../assets/images/features/email_campaign/email_usecase01.png'
import emailusecase02 from '../assets/images/features/email_campaign/email_usecase02.png'
import emailusecase03 from '../assets/images/features/email_campaign/email_usecase03.png'
import emailusecase04 from '../assets/images/features/email_campaign/email_usecase04.png'
import emailmockup01 from '../assets/images/features/email_campaign/email_mockup1.png'
import emailmockup02 from '../assets/images/features/email_campaign/email_mockup2.png'
import emailmockup03 from '../assets/images/features/email_campaign/email_mockup3.png'
import emailmockup04 from '../assets/images/features/email_campaign/email_mockup4.png'
import emailcta from '../assets/images/features/email_campaign/email_cta.png'
import formmockup01 from '../assets/images/features/forms/form_mockup1.png'
import formmockup02 from '../assets/images/features/forms/form_mockup2.png'
import formmockup03 from '../assets/images/features/forms/form_mockup3.png'
import formmockup04 from '../assets/images/features/forms/form_mockup4.png'
import formcta from '../assets/images/features/forms/form_cta.png'
import formusecase1 from '../assets/images/features/forms/form_usecase1.png'
import formusecase2 from '../assets/images/features/forms/form_usecase2.png'
import formusecase3 from '../assets/images/features/forms/form_usecase3.png'
import formusecase4 from '../assets/images/features/forms/form_usecase4.png'
import departmentmockup01 from '../assets/images/features/department/department_mockup1.png'
import departmentmockup02 from '../assets/images/features/department/department_mockup2.png'
import departmentmockup03 from '../assets/images/features/department/department_mockup3.png'
import feedbackmockup01 from '../assets/images/features/feedback/feedback_mockup01.png'
import feedbackmockup02 from '../assets/images/features/feedback/feedback_mockup02.png'
import feedbackmockup03 from '../assets/images/features/feedback/feedback_mockup03.png'
import Herobranch from '../assets/images/features/hero/hero_branch.png'
import HeroCampaign from '../assets/images/features/hero/hero_campaign.png'
import HeroForms from '../assets/images/features/hero/hero_forms.png'
import HeroDepartment from '../assets/images/features/hero/hero_department.png'

const FEATURE_PAGES_BASE = [
  {
    slug: 'branches',
    name: 'Branches',
    hero: {
      badge: 'Branches',
      title: 'One workspace for every branch you manage',
      description:
        'Organize feedback by location so each branch can track what matters, while HQ sees performance across all sites without manual reporting',
      primaryCtaLabel: 'Book a demo',
      primaryCtaHref: 'https://calendly.com/clientshot1/demo-call',
      secondaryCtaLabel: 'Start free',
      secondaryCtaHref: 'https://app.clientshot.com/sign-up',
      mediaImage: {
        src: Herobranch,
        alt: 'Branches hero preview',
      },
    },
    benefits: [
      { title: 'Cleaner branch reporting in minutes', highlight: true },
      { title: 'Faster follow-up by location', highlight: false },
      { title: 'Clear accountability across branch teams', highlight: false },
    ],
    blocks: [
      {
        title: 'Know what’s happening at each branch, instantly',
        description:
          'Filter dashboards by branch to see submissions, trends, and performance for one location or compare across locations.',
        ctaLabel: 'Explore dashboards',
        ctaHref: 'https://app.clientshot.com/sign-up',
        
      },
      {
        title: 'Keep branch data separated without extra work',
        description:
          'Branches help you avoid mixed reporting across locations so your data stays organized from day one',
        ctaLabel: 'Set up branches',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
        src: BranchList,
        alt: 'Mockup',
      },
      },
      {
        title: 'Give every team the right visibility',
        description:
          'Control access by branch so local teams focus on their location while admins maintain full oversight',
        ctaLabel: 'Manage access',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
        src: InviteBranch,
        alt: 'Mockup',
      },
      },
      {
        title: 'Export branch reports stakeholders can trust',
        description:
          'Generate branch-specific exports for reviews, donors, and internal check-ins without cleaning spreadsheets',
        ctaLabel: 'Export reports',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
        src: ExportBranch,
        alt: 'Mockup',
      },
      },
    ],
    useCases: {
      title: 'Branch Use Cases',
      items: [
        {
          title: 'Support Teams',
          description: 'Track complaints and praise in one place, reduce response times, and improve service quality',
          image: {
            src: branchusecase01,
            alt: 'Use case preview',
          },
        },
        {
          title: 'Product Managers',
          description: 'Understand what features delight or frustrate users and guide your roadmap with real user voice',
          image: {
            src: branchusecase02,
            alt: 'Use case preview',
          },
        },
        {
          title: 'Operations',
          description: 'Spot trends before they become top-tier problems and optimize processes based on feedback patterns',
          image: {
            src: branchusecase03,
            alt: 'Use case preview',
          },
        },
        {
          title: 'Customer Success',
          description: 'Measure satisfaction over time and proactively engage at-risk customers',
          image: {
            src: branchusecase04,
            alt: 'Use case preview',
          },
        },
      ],
    },
    cta: {
      title: 'Need help setting up your branches?',
      description:
        'We’ll help you structure branches, assign access, and confirm your reporting flow so you can go live quickly',
      buttonLabel: 'Talk to the team',
      buttonHref: '/contact',
      image: {
        src: BranchCta,
        alt: 'Mockup',
      },
    },
    faq: {
      title: 'FAQ',
      columns: [
        [
          {
            title: 'Can admins see all branches?',
            desc: 'Yes. Admins and HQ users can view performance, feedback, and activity across all branches from a centralized dashboard.',
          },
          {
            title: 'Can branch teams see other branches?',
            desc: 'No. Branch-level access is permission-based. Teams only see their own branch data unless broader visibility is granted by an administrator.',
          },
        ],
        [
          {
            title: 'Can I reuse the same form across branches?',
            desc: 'Yes. Forms can be reused and assigned to multiple branches, ensuring consistency while still allowing branch-level tracking and reporting.',
          },
          {
            title: 'Can I export data by branch?',
            desc: 'Yes. Data can be filtered and exported per branch, making it easy to analyze location-specific performance.',
          },
        ],
      ],
    },
  },
  {
    slug: 'email-campaign',
    name: 'Email Campaign',
    hero: {
      badge: 'Email Campaign',
      title: 'Reach the Right Customers With the Right Message Every Time',
      description:
        'Create, segment, automate, and send targeted email campaigns right from Clientshot — so the voice of the customer drives real engagement and measurable satisfaction',
      primaryCtaLabel: 'Book a demo',
      primaryCtaHref: 'https://calendly.com/clientshot1/demo-call',
      secondaryCtaLabel: 'Start free',
      secondaryCtaHref: 'https://app.clientshot.com/sign-up',
      mediaImage: {
        src: HeroCampaign,
        alt: 'Email campaign hero preview',
      },
    },
    benefits: [
      { title: 'Higher response & engagement rates', highlight: true },
      { title: 'Faster feedback‑driven decisions', highlight: false },
      { title: 'Better customer satisfaction signals loop', highlight: false },
    ],
    blocks: [
      {
        title: 'Target the right audience every time',
        description:
          'Create smart segments based on feedback, satisfaction levels, or behavior so your messages always feel relevant',
        ctaLabel: 'Create a segment',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: { 
          src: emailmockup01,
          alt: 'Email campaign mockup',
        },
      },
      {
        title: 'Turn feedback into meaningful follow-ups',
        description:
          'Respond to complaints, thank promoters, and update customers on improvements without leaving Clientshot',
        ctaLabel: 'Send a follow-up',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: { 
          src: emailmockup02,
          alt: 'Email campaign mockup',
        },
      },
      {
        title: 'Save time with reusable templates',
        description:
          'Design once, reuse anytime. Maintain brand consistency while launching campaigns in minutes',
        ctaLabel: 'Explore templates',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: { 
          src: emailmockup03,
          alt: 'Email campaign mockup',
        },
      },
      {
        title: 'Bring structure and accountability to your customer feedback',
        description:
          'Create departments, assign ownership, and resolve complaints faster all in one place',
        ctaLabel: 'View campaign insights',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: { 
          src: emailmockup04,
          alt: 'Email campaign mockup',
        },
      },
    ],
    useCases: {
      title: 'Use Cases',
      items: [
        {
          title: 'Close the feedback loop',
          description: 'Follow up with customers after feedback. Thank happy users, address concerns, and show that their voices lead to action',
          image: {
            src:emailusecase01,
            alt: 'Use case preview',
          },
        },
        {
          title: 'Re-engage silent or low-response customers',
          description: 'Segment feedback activity and send targeted nudges to inactive customers, boosting participation and data quality',
          image: {
            src:emailusecase02,
            alt: 'Use case preview',
          },
        },
        {
          title: 'Announce improvements driven by feedback',
          description: 'When you fix an issue or ship an update based on customer input, use email campaigns to tell the right audience what changed and why it matters to them',
          image: {
            src:emailusecase03,
            alt: 'Use case preview',
          },
        },
        {
          title: 'Run satisfaction and insight campaigns at scale',
          description: 'Send bulk surveys, NPS follow-ups, or service satisfaction emails to specific customer groups while still keeping the message relevant and personal',
          image: {
            src:emailusecase04,
            alt: 'Use case preview',
          },
        },
      ],
    },
    cta: {
      title: 'Turn Email Outreach Into Actionable Insights',
      description:
        'Launch campaigns, track engagement, and convert responses into prioritized improvements.',
      buttonLabel: 'Talk to the team',
      buttonHref: '/contact',
      image: {
        src: emailcta,
        alt: 'Feature CTA preview',
      },
    },
    faq: {
      title: 'FAQ',
      columns: [
        [
          {
            title: 'Can I reuse email designs for future campaigns?',
            desc: 'Yes. Email templates can be saved and reused for future campaigns, reducing setup time and maintaining brand consistency.',
          },
          {
            title: 'How do I choose who receives my emails?',
            desc: 'You can segment recipients based on feedback data, branch, customer attributes, or custom filters to target the right audience.',
          },
        ],
        [
          {
            title: 'Can I schedule emails instead of sending immediately?',
            desc: 'Yes. Campaigns can be scheduled to send at a specific date and time instead of being sent instantly.',
          },
          {
            title: 'How does this connect to customer feedback in Clientshot?',
            desc: 'Email campaigns can be powered by feedback data, allowing you to follow up on complaints, engage satisfied customers, or re-target specific customer segments.',
          },
        ],
        [
          {
            title: 'Will I be able to track performance?',
            desc: 'Yes. You can track metrics such as open rates, engagement, response trends, satisfaction scores, and resolution performance through built-in analytics dashboards.',
          },
        ],
      ],
    },
  },
  {
    slug: 'feedback',
    name: 'Feedback',
    hero: {
      badge: 'Feedback',
      title: 'Collect, Understand, and Act on Customer Feedback',
      description:
        'Capture customer voice across channels and transform every insight into measurable action.',
      primaryCtaLabel: 'Book a demo',
      primaryCtaHref: 'https://calendly.com/clientshot1/demo-call',
      secondaryCtaLabel: 'Start free',
      secondaryCtaHref: 'https://app.clientshot.com/sign-up',
      videoUrl: 'https://www.youtube.com/embed/_QmyvFOasGk',
    },
    benefits: [
      { title: 'Zero blind spots', highlight: true },
      { title: 'Faster issue resolution', highlight: false },
      { title: 'Stronger customer trust', highlight: false },
    ],
    blocks: [
      {
        title: 'Centralize feedback from every channel',
        description:
          'Collect complaints and commendations from Web, USSD, and WhatsApp in one organized dashboard.',
        ctaLabel: 'Explore dashboards',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
          src: feedbackmockup01,
          alt: 'Feedback feature mockup',
        },
      },
      {
        title: 'Turn complaints into structured action',
        description:
          'Track every issue from submission to resolution with clear ownership and status updates.',
        ctaLabel: 'Manage complaints',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
          src: feedbackmockup02,
          alt: 'Feedback feature mockup',
        },
      },
      {
        title: 'Recognize and amplify positive feedback',
        description:
          'Highlight commendations, reward top-performing teams, and strengthen morale.',
        ctaLabel: 'Track commendations',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
          src: feedbackmockup03,
          alt: 'Feedback feature mockup',
        },
      },
    ],
    useCases: {
      title: 'Feedback Use Cases',
      items: [
        {
          title: 'Manage service complaints across locations',
          description: 'Centralize feedback from multiple branches or service points.',
        },
        {
          title: 'Capture rural or offline feedback via USSD',
          description: 'Enable customers without smartphones or internet access to share their voice.',
        },
        {
          title: 'Track and celebrate commendations',
          description: 'Identify teams delivering exceptional service and reward performance.',
        },
        {
          title: 'Identify recurring operational issues',
          description: 'Spot patterns across products, services, or departments.',
        },
      ],
    },
    cta: {
      title: 'Turn Every Customer Voice Into Measurable Improvement',
      description:
        'Stop losing complaints in chats. Stop ignoring commendations. Start managing feedback like a system.',
      buttonLabel: 'Talk to the team',
      buttonHref: '/contact',
    },
    faq: {
      title: 'FAQ',
      columns: [
        [
          {
            title: 'What types of feedback can I collect with Clientshot?',
            desc: 'You can collect complaints, commendations, suggestions, surveys, CSAT ratings, and structured form responses across Web, USSD, and WhatsApp. Clientshot supports both quantitative scores and detailed qualitative feedback.',
          },
          {
            title: 'Does Clientshot calculate customer satisfaction scores?',
            desc: 'Yes. Clientshot automatically calculates satisfaction metrics such as CSAT and other rating-based insights from collected responses, helping teams monitor performance in real time.',
          },
        ],
        [
          {
            title: 'Can I export feedback for reporting?',
            desc: 'Yes. Feedback data can be exported for reporting and analysis, allowing you to generate internal reports or share insights with stakeholders.',
          },
          {
            title: 'What’s the fastest way to start collecting feedback?',
            desc: 'You can quickly create a form or enable a feedback channel (Web, USSD, or WhatsApp), share the link or code with customers, and begin collecting responses immediately.',
          },
        ],
      ],
    },
  },
  {
    slug: 'forms',
    name: 'Forms',
    hero: {
      badge: 'Forms',
      title: 'Collect Feedback That Flows, Adapts, and Drives Real Decisions',
      description:
        'Create powerful feedback forms, link them dynamically, merge them intelligently, and turn every response into actionable insight — all inside Clientshot.',
      primaryCtaLabel: 'Book a demo',
      primaryCtaHref: 'https://calendly.com/clientshot1/demo-call',
      secondaryCtaLabel: 'Start free',
      secondaryCtaHref: 'https://app.clientshot.com/sign-up',
      mediaImage: {
        src: HeroForms,
        alt: 'Forms hero preview',
      },
    },
    benefits: [
      { title: 'Higher quality feedback', highlight: true },
      { title: 'Structured, actionable insights', highlight: false },
      { title: 'Scalable feedback collection', highlight: false },
    ],
    blocks: [
      {
        title: 'Capture feedback exactly how you need it',
        description:
          'Build forms with custom questions, multiple formats, and flexible structure to collect the right data.',
        ctaLabel: 'Create a forms',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
          src: formmockup01,
          alt: 'Form mockup',
        },
      },
      {
        title: 'Link forms for dynamic feedback journeys',
        description:
          'Guide respondents from one form to another based on their answers, creating personalized experiences',
        ctaLabel: 'Link a form',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
          src: formmockup02,
          alt: 'Form linking',
        },
      },
      {
        title: 'Merge forms into one seamless experience',
        description:
          'Combine two or more forms into a single workflow to simplify large or multi-step feedback collection',
        ctaLabel: 'Merge forms',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
          src: formmockup03,
          alt: 'Form merging',
        },
      },
      {
        title: 'Real-time visibility on your dashboard',
        description:
          'View responses instantly, track trends, and act on insights without switching tools',
        ctaLabel: 'View responses',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
          src: formmockup04,
          alt: 'Dashboard preview',
        },
      },
    ],
    useCases: {
      title: 'Use Cases',
      items: [
        {
          title: 'Complaint and commendation collection',
          description: 'Create structured forms for customers to report issues or share praise',
          image: {
            src: formusecase1,
            alt: 'Use case preview',
          },
        },
        {
          title: 'Collect large-scale data from health facilities',
          description: 'Design structured forms for hospitals, clinics, and field agents to submit patient feedback, service quality reports, or operational data at scale',
          image: {
            src: formusecase2,
            alt: 'Use case preview',
          },
        },
        {
          title: 'Customer satisfaction and NPS surveys',
          description: 'Collect structured satisfaction data and route responses directly into dashboards and departments for action',
          image: {
            src: formusecase3,
            alt: 'Use case preview',
          },
        },
        {
          title: 'Field data collection for distributed teams',
          description: 'Enable agents, inspectors, or field officers to submit structured reports from multiple locations using shareable links',
          image: {
            src: formusecase4,
            alt: 'Use case preview',
          },
        },
      ],
    },
    cta: {
      title: 'Build feedback experiences that actually work',
      description:
        'Create smarter forms, connect them dynamically, and turn every response into real action',
      buttonLabel: 'Talk to the team',
      buttonHref: '/contact',
      image: {
        src: formcta,
        alt: 'Form use case 1',
      },
    },
    faq: {
      title: 'FAQ',
      columns: [
        [
          {
            title: 'Can I create different types of forms?',
            desc: 'Yes. You can build dynamic forms with multiple question types including ratings, multiple choice, text inputs, and conditional logic to capture structured feedback.',
          },
          {
            title: 'Can forms be linked or reused?',
            desc: 'Yes. Forms can be reused across branches and linked to workflows, allowing you to maintain consistency while scaling feedback collection.',
          },
        ],
        [
          {
            title: 'Can I customize forms for different branches?',
            desc: 'Yes. While you can reuse a base form, you can also tailor forms per branch to reflect location-specific needs.',
          },
          {
            title: 'Can I track form performance?',
            desc: 'Yes. You can monitor submission rates, response trends, and satisfaction scores directly from the dashboard.',
          },
        ],
      ],
    },
  },
  {
    slug: 'department',
    name: 'Department',
    hero: {
      badge: 'Department',
      title: 'Handle Every Complaint With Clarity, Ownership, and Accountability',
      description:
        'Organize feedback by department, assign clear owners, and resolve complaints faster without confusion or handoffs falling through the cracks',
      primaryCtaLabel: 'Book a demo',
      primaryCtaHref: 'https://calendly.com/clientshot1/demo-call',
      secondaryCtaLabel: 'Start free',
      secondaryCtaHref: 'https://app.clientshot.com/sign-up',
      mediaImage: {
        src: HeroDepartment,
        alt: 'Department hero preview',
      },
    },
    benefits: [
      { title: 'Faster resolution times', highlight: true },
      { title: 'Clear ownership and accountability', highlight: false },
      { title: 'Better internal collaboration', highlight: false },
    ],
    blocks: [
      {
        title: 'Create clear ownership for every ticket',
        description:
          'Assign complaints and commendations to the right department and team lead so nothing slips through the cracks',
        ctaLabel: 'Set up a department',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
          src: departmentmockup01,
          alt: 'Mockup',
        },
      },
      {
        title: 'Resolve issues faster and smarter',
        description:
          'Route feedback directly to the people responsible, reducing internal back and forth and speeding up resolution time',
        ctaLabel: 'Assign a team lead',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
          src: departmentmockup02,
          alt: 'Mockup',
        },
      },
      {
        title: 'Stay organized as you scale',
        description:
          'Control access by branch so local teams focus on their location while admins maintain full oversight',
        ctaLabel: 'Organize your teams',
        ctaHref: 'https://app.clientshot.com/sign-up',
        image: {
          src: departmentmockup03,
          alt: 'Mockup',
        },
      },
    ],
    useCases: {
      title: 'Department Use Cases',
      items: [
        {
          title: 'Organize complaints across large teams',
          description: 'Perfect for organizations handling feedback across multiple functions, locations, or services',
          image: {
            src: formusecase1,
            alt: 'Use case preview',
          }
        },
        {
          title: 'Improve accountability in customer support',
          description: 'Ensure every complaint has a clear owner who is responsible for resolution and updates',
          image: {
            src: formusecase2,
            alt: 'Use case preview',
          }
        },
        {
          title: 'Manage complaints alongside commendations',
          description: 'Route praise to the right teams, not just problems, boosting morale and recognition',
          image: {
            src: formusecase3,
            alt: 'Use case preview',
          }
        },
        {
          title: 'Scale feedback operations without chaos',
          description: 'As feedback volume grows, departments keep things structured, calm, and efficient',
          image: {
            src: formusecase4,
            alt: 'Use case preview',
          }
        },
      ],
    },
    cta: {
      title: 'Bring structure and accountability to your customer feedback',
      description:
        'Create departments, assign ownership, and resolve complaints faster all in one place',
      buttonLabel: 'Talk to the team',
      buttonHref: '/contact',
      image: {
        src: emailcta,
        alt: 'Mockup',
      },
    },
    faq: {
      title: 'FAQ',
      columns: [
        [
          {
            title: 'Can feedback be assigned to specific departments?',
            desc: 'Yes. Feedback can be automatically or manually routed to the appropriate department to ensure clear ownership and faster resolution.',
          },
          {
            title: 'Can departments have their own team members?',
            desc: 'Yes. Each department can have assigned members with role-based permissions to manage and resolve tickets.',
          },
        ],
        [
          {
            title: 'Can I track performance by department?',
            desc: 'Yes. You can analyze resolution time, ticket volume, and satisfaction trends per department.',
          },
          {
            title: 'Can departments collaborate on a single issue?',
            desc: 'Yes. Issues can be reassigned or shared across departments to ensure the right team handles each case efficiently.',
          },
        ],
      ],
    },
  },
]

const defaultBlockImage = {
  src: BranchFilterImage,
  alt: 'Branch filter preview',
}

const defaultCtaImage = {
  src: BranchCta,
  alt: 'Feature CTA preview',
}

const defaultUseCaseImage = {
  src: BranchFilterImage,
  alt: 'Feature use case preview',
}

const FEATURE_PAGES = FEATURE_PAGES_BASE.map((page) => ({
  ...page,
  blocks: page.blocks.map((block) => ({
    ...block,
    image: block.image || defaultBlockImage,
  })),
  useCases: {
    ...page.useCases,
    items: page.useCases.items.map((item) => ({
      ...item,
      image: item.image || defaultUseCaseImage,
    })),
  },
  cta: {
    ...page.cta,
    image: page.cta.image || defaultCtaImage,
  },
}))

const FEATURE_PAGE_MAP = FEATURE_PAGES.reduce((acc, item) => {
  acc[item.slug] = item
  return acc
}, {})

export { FEATURE_PAGES, FEATURE_PAGE_MAP }
